import React from 'react'
import {Link} from 'react-router-dom'
import CarIcon from '../../../assets/imgs/new-vanshare/car1.svg'
import LocaleText from '../../common/LocaleText'
import {useLocale} from '../../hocs/hooks'
import styles from './HomeStatement.scss'

const HomeStatement = () => {
  const locale = useLocale()
  return <>
    <div className={['container', styles.container].join(' ')}>
      <div className={[styles.title].join(' ')}>
        Stay Anywhere, Anytime.
      </div>
      {/* PC */}
      <div>
        <div className={[styles.text, styles.mt40].join(' ')}>
          衣食住を詰め込んだ「バン」に
          <br className='d-block d-sm-none'/>
          乗り込み走り出せば、
          <br className='d-block d-sm-none'/>
          <br className='d-sm-block d-none'/>
          いつでも、どこでも、好きな人と、
          <br className='d-block d-sm-none'/>
          好きなことをして
          <br className='d-sm-block d-none'/>
          自由な生き方を実現できる、
          <br className='d-block d-sm-none'/>
          <span className={styles.otherFont}>VANLIFE</span>。
        </div>
        <div className={[styles.text].join(' ')}>
          <span className={styles.otherFont}>Carstay</span>は、誰もがかんたんに
          <br className='d-block d-sm-none'/>
          <span className={styles.otherFont}>VANLIFE</span>を楽しめるよう
          <br className='d-block d-sm-none'/>
          <br className='d-sm-block d-none'/>
          キャンピングカーやバンの
          <br className='d-block d-sm-none'/>
          カーシェア・レンタル、
          <br className='d-block d-sm-none'/>
          <br className='d-sm-block d-none'/>
          車中泊用のスペースシェアサービスを
          <br className='d-block d-sm-none'/>
          展開しています。
        </div>
        <div className='d-flex justify-content-center'>
          <Link
            to={`/${locale}/company/`}
            className={['btn btn-primary rounded-pill btn-lg`', styles.btn].join(' ')}
          >
            <LocaleText
              ja="会社情報・ニュースリリースはこちら"
              en="Company information and news releases"
            />
          </Link>
        </div>
      </div>
    </div>
    <div className={styles.space}/>
    <div className={[styles.road, 'position-relative'].join(' ')}>
      <div className={[styles.carImg, 'position-relative'].join(' ')}>
        <CarIcon className={styles.carIcon} />
      </div>
    </div>
  </>
}
HomeStatement.displayName = 'Definition'
export default HomeStatement
